export const route = [
  {
    path: '/',
    component: () => import('./components/index.vue'),
    children: [
      {
        path: '',
        name: 'dashboard',
        component: () => import('./components/dashboard/dashboard.vue'),
        meta: {moduleId: 'home', title: '首页', icon: 'home', perm: 'show'},
        children: []
      },
      {
        path: '/purchase',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'purchase', title: '疫苗采购', icon: 'purchase', perm: 'purchasing-business'},
        children: [
          {
            path: '/purchase/contract',
            name: 'purchaseContract',
            component: () => import('./components/purchase/contract/list.vue'),
            meta: {moduleId: 'purchase', title: '采购合同', perm: 'purchasing-contract'}
          },
          {
            path: '/purchase/order/one/class/list',
            name: 'purchaseOrderOneClass',
            component: () => import('./components/purchase/order/list-one-class.vue'),
            meta: {moduleId: 'purchase', title: '免疫规划苗采购订单', perm: 'purchasing-order', type: '1'}
          },
          {
            path: '/purchase/order/two/class/list',
            name: 'purchaseOrderTwoClass',
            component: () => import('./components/purchase/order/list-two-class.vue'),
            meta: {
              moduleId: 'purchase',
              title: '非免疫规划苗采购订单',
              perm: 'second-vaccine-purchasing-order',
              type: '2'
            }
          },
          {
            path: '/purchase/rejected/list',
            name: 'purchaseRejected',
            component: () => import('./components/purchase/rejected/list.vue'),
            meta: {moduleId: 'purchase', title: '采购退货', perm: 'return-manager'}
          },
          {
            path: '/pov/request',
            name: 'povRequest',
            component: () => import('./components/pov/request/list.vue'),
            meta: {moduleId: 'pov', title: '要货申请', perm: 'pull-signal'}
          },
          {
            path: '/pov/return/request/list',
            name: 'povReturnRequestList',
            component: () => import('./components/purchase/returnRequest/list-pov.vue'),
            meta: {moduleId: 'pov', title: '退货申请', perm: 'return-request-query', type: 'pov'}
          },
          {
            path: '/purchase/allocation',
            name: 'purchaseAllocationIndex',
            component: () => import('./components/purchase/collect/list.vue'),
            meta: {moduleId: 'pov', title: '采购汇总', perm: 'purchansing-assignment'}
          },
          {
            path: '/purchase/allocation/task',
            name: 'purchaseAllocationTask',
            component: () => import('./components/purchase/collect/allocation.vue'),
            meta: {moduleId: 'pov', title: '采购汇总详情', perm: 'purchansing-assignment', hidden: true}
          },
          {
            path: '/purchase/transit',
            name: 'purchaseTransit',
            component: () => import('./components/purchase/transit/list.vue'),
            meta: {moduleId: 'purchase', title: '在途疫苗跟踪', perm: 'transit-vaccine-manage'}
          },
        ]
      },
      {
        path: '/sale',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'sale', title: '疫苗销售', icon: 'sale', perm: 'sales-business'},
        children: [
          {
            path: '/sale/order/one/class/list',
            name: 'saleOrderOneClass',
            component: () => import('./components/sale/order/list-one-class.vue'),
            meta: {moduleId: 'sale', title: '免疫规划苗销售订单', perm: 'sales-order', type: '1'}
          },
          {
            path: '/sale/order/two/class/list',
            name: 'saleOrderTwoClass',
            component: () => import('./components/sale/order/list-two-class.vue'),
            meta: {moduleId: 'sale', title: '非免疫规划苗销售订单', perm: 'second-vaccine-sales-order', type: '2'}
          },
          {
            path: '/sale/no/feedback/list',
            name: 'saleNoFeedback',
            component: () => import('./components/sale/feedback/list.vue'),
            meta: {moduleId: 'sale', title: '未反馈订单', perm: 'no-feedback-order-manager'}
          },
          {
            path: '/sale/pov/list',
            name: 'salePovIndex',
            component: () => import('./components/purchase/pov/list.vue'),
            meta: {moduleId: 'sale', title: '要货需求', perm: 'demand-assignment'}
          },
          {
            path: '/sale/allocation/pov',
            name: 'saleAllocationPov',
            component: () => import('./components/purchase/pov/allocation-pov.vue'),
            meta: {moduleId: 'sale', title: '要货需求分配', perm: 'demand-assignment-update', hidden: true}
          },
          {
            path: '/sale/allocation',
            name: 'saleAllocationIndex',
            component: () => import('./components/purchase/wave/list.vue'),
            meta: {moduleId: 'sale', title: '销售分配', perm: 'cerp-create-wave'},
          },
          {
            path: '/sale/allocation/task',
            name: 'saleAllocationTask',
            component: () => import('./components/purchase/pov/allocation-sale.vue'),
            meta: {moduleId: 'sale', title: '销售分配详情', perm: 'cerp-create-wave-query', hidden: true}
          },
          {
            path: '/sale/rejected/list',
            name: 'saleRejected',
            component: () => import('./components/sale/rejected/list.vue'),
            meta: {moduleId: 'sale', title: '销售退货', perm: 'sales-return'}
          },
          {
            path: '/cdc/return/request/list',
            name: 'cdcReturnRequestList',
            component: () => import('./components/purchase/returnRequest/list-cdc.vue'),
            meta: {moduleId: 'sale', title: '退货申请', perm: 'sub-unit-return-request-query', type: 'cdc'}
          },
          {
            path: '/pov/record',
            name: 'povRecord',
            component: () => import('./components/pov/record/list.vue'),
            meta: {moduleId: 'pov', title: '注射记录', perm: 'injection-task-manager'}
          },
          {
            path: '/pov/scan-code-record',
            name: 'povScanCodeRecord',
            component: () => import('./components/pov/scan-code-record/list.vue'),
            meta: {moduleId: 'pov', title: '扫码验证签核记录', perm: 'injection-signed-manager'}
          },
          {
            path: '/pov/subordinate/scan-code-record',
            name: 'povSubordinateScanCodeRecord',
            component: () => import('./components/pov/scan-code-record/subordinate/list.vue'),
            meta: {moduleId: 'pov', title: '下属单位扫码验证签核记录', perm: 'injection-subordinate-signed-manager'}
          },
          {
            path: '/pov/injection-task',
            name: 'povInjectionTask',
            component: () => import('./components/pov/inoculate/injection/index.vue'),
            meta: {moduleId: 'pov', title: '接种任务', perm: 'injection-task-info-manager'}
          },
          {
            path: '/pov/inoculate/vaccine/each',
            name: 'povInoculateVaccineEach',
            component: () => import('./components/pov/inoculate/vaccine-each/index'),
            meta: {moduleId: 'pov', title: '多人份剂次时效记录', perm: 'query-multi-person-aging'}
          },
          {
            path: '/pov/subordinate/record',
            name: 'povSubordinateRecord',
            component: () => import('./components/pov/record/subordinate/list.vue'),
            meta: {moduleId: 'pov', title: '下属单位注射记录', perm: 'subordinate-injection-task-manager'}
          }
        ]
      },
      {
        path: '/store',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'store', title: '库存管理', icon: 'store', perm: 'cerp-stock-manager'},
        children: [
          {
            path: '/store/storeRequest',
            name: 'storeRequest',
            component: () => import('./components/store/list-request.vue'),
            meta: {moduleId: 'store', title: '即时库存', perm: 'cerp-stock-query-bizServing'}
          },
          {
            path: '/store/stockBizServing',
            name: 'stockBizServing',
            component: () => import('./components/store/list-biz-serving.vue'),
            meta: {moduleId: 'store', title: '即时库存(含人份)', perm: 'cerp-stock-query', isBizServing: true}
          },
          {
            path: '/store/count/adjust',
            name: 'storeCountAdjustIndex',
            component: () => import('./components/store/adjust-count-stock-log.vue'),
            meta: {moduleId: 'store', title: '库存数量调整', perm: 'cerp-stock-adjust-query', subMenuId: 'count'}
          },
          {
            path: '/store/count/adjust/detail',
            name: 'storeCountAdjustDetail',
            component: () => import('./components/store/adjust-count-stock.vue'),
            meta: {moduleId: 'store', title: '库存数量调整详情', perm: 'cerp-stock-adjust-query', hidden: true}
          },
          {
            path: '/store/adjust/status',
            name: 'storeAdjustStatus',
            component: () => import('./components/store/record/list'),
            meta: {moduleId: 'store', title: '库存状态调整', perm: 'cerp-stock-status-adjust'}
          },
          {
            path: '/store/record-entering',
            name: 'storeRecordEntering',
            component: () => import('./components/store/record-entering/list'),
            meta: {moduleId: 'store', title: '期初库存录入', perm: 'cerp-stock-batch-adjust'}
          },
          {
            path: '/store/inventory',
            name: 'storeInventoryIndex',
            component: () => import('./components/store/inventory/list.vue'),
            meta: {moduleId: 'store', title: '库存盘点', perm: 'erp-stock-inventory-query', subMenuId: 'inventory'}
          },
          {
            path: '/store/inventory/detail',
            name: 'storeInventoryDetail',
            component: () => import('./components/store/inventory/details.vue'),
            meta: {moduleId: 'store', title: '库存盘点详情', perm: 'erp-stock-inventory-query', hidden: true}
          },
          {
            path: '/store/history/bizServing',
            name: 'storeHistoryBizServing',
            component: () => import('./components/store/history-store-biz.vue'),
            meta: {
              moduleId: 'store',
              title: '历史库存查询(含人份)',
              perm: 'cerp-stock-query-history',
              isBizServing: true
            }
          },
          {
            path: '/store/history',
            name: 'storeHistory',
            component: () => import('./components/store/history-store.vue'),
            meta: {moduleId: 'store', title: '历史库存查询', perm: 'cerp-stock-query-history-bizServing'}
          },
          {
            path: '/store/allotment/list',
            name: 'storeAllotment',
            component: () => import('./components/purchase/allotment/list.vue'),
            meta: {moduleId: 'purchase', title: '调拨入库', perm: 'allocating-order-manager'}
          },
          {
            path: '/store/allotment/out/list',
            name: 'storeAllotmentOut',
            component: () => import('./components/store/allotment-out/list.vue'),
            meta: {moduleId: 'purchase', title: '调拨出库', perm: 'allocating-out-order-manager'}
          },
          {
            path: '/store/bad/out/list',
            name: 'storeBadOut',
            component: () => import('./components/store/breakage-order/list.vue'),
            meta: {moduleId: 'store', title: '报损出库', perm: 'breakage-order'}
          },
          {
            path: '/store/subordinate/loss-report/list',
            name: 'storeSubordinateLossReport',
            component: () => import('./components/store/breakage-order-subordinate/index'),
            meta: {moduleId: 'store', title: '下属单位报损单', perm: 'subordinate-unit_loss_report'}
          },
          {
            path: '/store/loss/fill/list',
            name: 'storeLossFill',
            component: () => import('./components/store/loss-fill/loss-fill-list.vue'),
            meta: {moduleId: 'store', title: '损耗填报', perm: 'wastage-order'}
          },
          {
            path: '/store/cancelApplication/index',
            name: 'storeCancelApplicationIndex',
            component: () => import('./components/store/cancelApplication/index.vue'),
            meta: {moduleId: 'store', title: '撤销报损申请', perm: 'revoke-breakage-apply'}
          }
        ]
      },
      {
        path: '/file',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'file', title: '批号文件管理', icon: 'validity', perm: 'vaccine-batch-process'},
        children: [
          {
            path: '/file/vaccine',
            name: 'fileVaccine',
            component: () => import('./components/files/vaccineBatch/index.vue'),
            meta: {moduleId: 'file', title: '疫苗批号文件', perm: 'vaccine-batch-process'}
          }
        ]
      },
      {
        path: '/finance',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'finance', title: '财务管理', icon: 'finance', perm: 'financial-manager'},
        children: [
          {
            path: '/finance/pay',
            name: 'financePay',
            component: () => import('./components/finance/pay/list.vue'),
            meta: {moduleId: 'finance', title: '应付账款查询', perm: 'accounts-payable'}
          },
          {
            path: '/finance/get',
            name: 'financeGet',
            component: () => import('./components/finance/receipt/list.vue'),
            meta: {moduleId: 'finance', title: '应收账款查询', perm: 'accounts-receivable'}
          },
          {
            path: '/payment/invoice',
            name: 'paymentInvoice',
            component: () => import('./components/finance/invoice/list.vue'),
            meta: {moduleId: 'finance', title: '厂商发票管理', perm: 'invoice-data-manager'}
          },
          {
            path: '/payment/operation',
            name: 'paymentOperation',
            component: () => import('./components/finance/operation/payment/list.vue'),
            meta: {moduleId: 'finance', title: '付款作业', perm: 'payment-payable'}
          },
          {
            path: '/collection/pov',
            name: 'collectionPov',
            component: () => import('./components/finance/operation/collection/list-pov.vue'),
            meta: {
              moduleId: 'finance', title: 'POV付款作业', perm: 'pov-payment-payable', type: 1,
              perms: ['pov-payment-payable-add', 'pov-payment-payable-audit', 'pov-payment-payable-cancel']
            }
          },
          {
            path: '/pending/payment',
            name: 'pendingPayment',
            component: () => import('./components/finance/pending/list-payment.vue'),
            meta: {moduleId: 'finance', title: '预付款管理', perm: 'cdc-advance-payable', type: 1}
          },
          {
            path: '/pending/receive',
            name: 'pendingReceive',
            component: () => import('./components/finance/pending/list-receive.vue'),
            meta: {moduleId: 'finance', title: '预收款管理', perm: 'pov-advance-receivable', type: 2}
          },
          {
            path: '/collection/operation',
            name: 'collectionOperation',
            component: () => import('./components/finance/operation/collection/list-operation.vue'),
            meta: {
              moduleId: 'finance', title: '收款作业', perm: 'cdc-payment-receivable', type: 2,
              perms: ['cdc-payment-receivable-add', 'cdc-payment-receivable-audit',
                'cdc-payment-receivable-review', 'cdc-payment-receivable-cancel']
            }
          },
          {
            path: '/payment/pending',
            name: 'paymentPending',
            component: () => import('./components/finance/operation/advance/list-payment.vue'),
            meta: {
              moduleId: 'finance', title: '预付款作业', perm: 'advance-payable', type: 1,
              perms: ['advance-payable-add', 'advance-payable-audit', 'advance-payable-cancel']
            }
          },
          {
            path: '/collection/pending',
            name: 'collectionPending',
            component: () => import('./components/finance/operation/advance/list-collection.vue'),
            meta: {
              moduleId: 'finance', title: '预收款作业', perm: 'advance-receivable', type: 2,
              perms: ['advance-receivable-add', 'advance-receivable-audit', 'advance-receivable-review', 'advance-receivable-cancel']
            }
          },
          {
            path: '/finance/supplier',
            name: 'financeSupplier',
            component: () => import('./components/finance/vaccine/list.vue'),
            meta: {moduleId: 'finance', title: '疫苗入库明细', perm: 'vaccine-vendor-reconciliation'}
          }
        ]
      },
      {
        path: '/report',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'report', title: '报表管理', icon: 'report', perm: 'report-form-manager'},
        children: [
          {
            path: '/report/loss',
            name: 'reportLoss',
            component: () => import('./components/report/LossReport'),
            meta: {moduleId: 'report', title: '损耗报表', perm: 'wastage-report-vss'}
          },
          {
            path: '/report/trace-code',
            name: 'reportTraceCode',
            component: () => import('./components/report/TraceCodeReport'),
            meta: {moduleId: 'report', title: '追溯码使用情况报表', perm: 'trace-code-report-vss'}
          },
          {
            path: '/report/trace-code-download',
            name: 'reportTraceCodeDownload',
            component: () => import('./components/report/TraceCodeDownload'),
            meta: {moduleId: 'report', title: '我的下载', perm: 'trace-code-download-vss'}
          },
          {
            path: '/report/purchase',
            name: 'reportPurchase',
            component: () => import('./components/report/purchase.vue'),
            meta: {moduleId: 'report', title: '采购明细表', perm: 'purchasing-detail-form-manager'}
          },
          {
            path: '/report/purchase-detail',
            name: 'reportPurchaseDetail',
            component: () => import('./components/report/purchase-detail.vue'),
            meta: {moduleId: 'report', title: '采购明细表（详细）', perm: 'sz-purchasing-detail-form-manager'}
          },
          {
            path: '/report/sale',
            name: 'reportSale',
            component: () => import('./components/report/sale.vue'),
            meta: {moduleId: 'report', title: '销售明细表', perm: 'sale-detail-form-manager'}
          },
          {
            path: '/report/out',
            name: 'reportOut',
            component: () => import('./components/report/out.vue'),
            meta: {moduleId: 'report', title: '出货一览表', perm: 'shipment-form-manager'}
          },
          {
            path: '/warehouse/report',
            name: 'warehouseReport',
            component: () => import('./components/report/warehouse-report'),
            meta: {moduleId: 'report', title: '出入库登记表导出', perm: 'warehouse-report-export'}
          },
          {
            path: '/drug-administration/report/in',
            name: 'drugAdministrationReportIn',
            component: () => import('./components/report/drug-administration-in.vue'),
            meta: {
              moduleId: 'report',
              title: '市药监购进数据导出',
              perm: 'drug-administration-in-data-export',
              type: '0'
            }
          },
          {
            path: '/drug-administration/report/out',
            name: 'drugAdministrationReportOut',
            component: () => import('./components/report/drug-administration-out.vue'),
            meta: {
              moduleId: 'report',
              title: '市药监销售数据导出',
              perm: 'drug-administration-out-data-export',
              type: '1'
            }
          },
          {
            path: '/report/repertory',
            name: 'reportRepertory',
            component: () => import('./components/report/repertory.vue'),
            meta: {moduleId: 'report', title: '进销存盘点表', perm: 'inventory-form-manager'}
          },
          {
            path: '/report/shenzhen-repertory',
            name: 'reportShenzhenRepertory',
            component: () => import('./components/report/shenzhen-repertory.vue'),
            meta: {moduleId: 'report', title: '进销存盘点表(深圳专用)', perm: 'shenzhen-inventory-form-manager'}
          },
          {
            path: '/report/first/out/manager',
            name: 'reportFirstOutManager',
            component: () => import('./components/report/one-out.vue'),
            meta: {moduleId: 'report', title: '免疫规划疫苗各区出货统计表', perm: 'first-vaccine-out-form-manager'}
          },
          {
            path: '/report/month/repertory',
            name: 'reportMonthRepertory',
            component: () => import('./components/report/month-end-repertory.vue'),
            meta: {
              moduleId: 'report',
              title: '非免疫规划疫苗月终库存盘点表',
              perm: 'month-stock-inventory-form-manager'
            }
          },
          {
            path: '/report/logistics',
            name: 'reportLogistics',
            component: () => import('./components/report/logistics.vue'),
            meta: {moduleId: 'report', title: '免费疫苗出入库明细表', perm: 'first-vaccine-logistics-manager'}
          },
          {
            path: '/report/allotation',
            name: 'reportAllotation',
            component: () => import('./components/report/allotation.vue'),
            meta: {moduleId: 'report', title: '出货疫苗统计表', perm: 'first-vaccine-distribution-manager'}
          },
          {
            path: '/report/pov/two/repertory',
            name: 'reportPovTwoRepertory',
            component: () => import('./components/report/pov-repertory.vue'),
            meta: {moduleId: 'report', title: '接种单位疫苗盘点表', perm: 'pov-stock-form-manager', type: 2}
          },
          {
            path: '/report/pov/detail',
            name: 'reportPovDetail',
            component: () => import('./components/report/factoryOrder.vue'),
            meta: {moduleId: 'report', title: '全市出入库明细', perm: 'stock-in-out-form-manager'}
          },
          {
            path: '/report/pov/inout/detail',
            name: 'reportPovInoutDetail',
            component: () => import('./components/report/povInoutDetailOrder.vue'),
            meta: {moduleId: 'report', title: '接种点疫苗出入库明细', perm: 'pov-in-out-detail-manager'}
          },
          {
            path: '/report/goods-settlement',
            name: 'reportGoodsSettlement',
            component: () => import('./components/report/goods-settlement.vue'),
            meta: {moduleId: 'report', title: '疫苗当月结算表', perm: 'vaccine-month-settlement-manager'}
          },
          {
            path: '/report/cdc/first-vaccine',
            name: 'reportCdcFirstVaccine',
            component: () => import('./components/report/cdc-first-vaccine.vue'),
            meta: {moduleId: 'report', title: '免疫规划苗领用记录', perm: 'cdc-free-vaccine-sale-manager'}
          },
          {
            path: '/report/receive',
            name: 'reportReceive',
            component: () => import('./components/report/receive.vue'),
            meta: {moduleId: 'report', title: '各单位领苗汇总表', perm: 'each-year-vaccine-manager'}
          },
          {
            path: '/report/quality-acceptance',
            name: 'reportQualityAcceptance',
            component: () => import('./components/report/quality-acceptance-record.vue'),
            meta: {moduleId: 'report', title: '疫苗质量验收记录表', perm: 'vaccine-quality-check-record-manager'}
          },
          {
            path: '/report/vaccine-biz-record',
            name: 'reportVaccineBizRecord',
            component: () => import('./components/report/vaccine-biz-record.vue'),
            meta: {moduleId: 'report', title: '疫苗出入库记录表', perm: 'vaccine-biz-record-manager'}
          },
          {
            path: '/report/material-stock',
            name: 'reportMaterialStock',
            component: () => import('./components/report/material-stock.vue'),
            meta: {moduleId: 'report', title: '物料进销存汇总表', perm: 'materia-stock-manager'}
          },
          {
            path: '/report/trend',
            name: 'reportTrend',
            component: () => import('./components/report/use-trend.vue'),
            meta: {moduleId: 'report', title: '疫苗使用趋势表', perm: 'vaccine-trend-manager'}
          },
          {
            path: '/report/vaccine/use',
            name: 'reportVaccineUse',
            component: () => import('./components/report/use-records.vue'),
            meta: {
              moduleId: 'report',
              title: '疫苗使用情况统计',
              perm: 'query-multi-person-aging',
              icon: 'el-icon-t-baobiao'
            }
          },
          {
            path: '/report/receive/records',
            name: 'reportReceiveRecords',
            component: () => import('./components/report/receive-record.vue'),
            meta: {moduleId: 'report', title: '收货记录表', perm: 'erp-receiving-record-query'}
          },
          {
            path: '/report/cdc/out-amount/summary',
            name: 'reportCdcOutAmountSummary',
            component: () => import('./components/report/cdc-out-amount-summary.vue'),
            meta: {moduleId: 'report', title: '非免疫规划疫苗出库单金额汇总报表', perm: 'cdc-out-amount-summary-query'}
          }
        ]
      },
      {
        path: '/resource',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'resource', title: '资料管理', icon: 'firm', perm: 'material-manager'},
        children: [
          {
            path: '/resource/firm',
            name: 'resourceFirm',
            component: () => import('./components/resource/firm/list.vue'),
            meta: {moduleId: 'resource', title: '疫苗供货单位资料', perm: 'manufacturer-manager'}
          },
          {
            path: '/resource/second-vaccin/list',
            name: 'resourceSecondVaccinList',
            component: () => import('./components/resource/vaccin/secondVaccin/list.vue'),
            meta: {moduleId: 'resource', title: '疫苗产品资料', perm: 'second-vaccine-info'}
          },
          {
            path: '/resource/store',
            name: 'resourceStore',
            component: () => import('./components/resource/store/list.vue'),
            meta: {moduleId: 'resource', title: '仓库管理', perm: 'binding-warehouse'}
          },
          {
            path: '/resource/material',
            name: 'resourceMaterial',
            component: () => import('./components/resource/material/list.vue'),
            meta: {moduleId: 'resource', title: '物料管理', perm: 'supplies-manager'}
          }
        ]
      },
      {
        path: '/sys/setting',
        name: 'sysSetting',
        component: () => import('./components/common/parent-route.vue'),
        meta: {moduleId: 'sys', title: '系统设置', icon: 'sys-setting', perm: 'vss-sys-setting'},
        children: [
          {
            path: '/sys/setting/switch',
            name: 'sysSettingSwitch',
            component: () => import('./components/resource/codeSwitch/codeSwitch.vue'),
            meta: {moduleId: 'sys', title: '扫码开关', perm: 'scan-code-switch'}
          }
        ]
      }
    ]
  }
];

export const basicRoutes = [
  {path: '/resetpsw', name: 'resetpsw', component: () => import('./components/resetpsw.vue')},
  {path: '/404', name: 'page404', component: () => import('./components/error_404.vue')},
  {path: '/500', name: 'page500', component: () => import('./components/error_500.vue')},
  {path: '/login', name: 'login', component: () => import('./components/login.vue')},
  {path: '/wx/login', name: 'wxLogin', component: () => import('./components/wx-login.vue')},
  {path: '/forget', name: 'forget', component: () => import('./components/forget.vue')},
  {path: '/code/:id', name: 'codeResetPwd', component: () => import('./components/resetpwd.vue')}
];

export const ErrorPage = [
  {path: '*', name: 'errorPageAll', component: () => import('./components/error_404.vue')}
];
